<template>
  <div class="" >
    <div class="card card-container-outline">
      <img class='tag-highlight' v-if="product.tag === 'coming-soon'" src="../assets/img/tag_coming-soon.png">
      <img class='tag-highlight' v-if="product.tag === 'bestseller'" src="../assets/img/tag_best-seller.png">
      <img class='tag-highlight' v-if="product.tag === 'new-release'" src="../assets/img/tag_new-release.png">
      <img class="hero" :src="require(`../assets/img/product/${product.heroImg}`)" @click="goToLink(product.link)">
      <div class="row space-between">
        <div class="info-block">
          <p class="title blue">{{product.projectName}}</p>
          <p class="tagline blue">{{product.subtitle}}</p>
        </div>
        <img class="icon" src="../assets/img/icon_arrow.png">
      </div>
    </div>
<!--    <router-link :to="{ name: 'product', params: { productName: product.slug }}" class="button-outline">Learn more</router-link>-->
  </div>
</template>

<script>
import router from '../router/index.js'

export default {
  name: "ProductLearnMore",
  props: ['product'],
  data() {
    return {
      animated: false
    };
  },
  methods: {
    goToLink(slug) {
      router.push(slug)
    },
    handleScroll() {
      if (this.animated || !this.$el) return;

      const rect = this.$el.getBoundingClientRect();

      if (rect.top <= window.innerHeight - 100) {
        this.animated = true;
        this.$el.classList.add('animate-now');
        window.removeEventListener('scroll', this.checkScroll);
      }
    }
  },
  mounted() {
   this.checkScroll = this.handleScroll.bind(this);
    setTimeout(() => {
      window.addEventListener('scroll', this.checkScroll);
      this.handleScroll();
    }, 100)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.checkScroll);
  },
}
</script>

<style scoped lang="scss">
@import "../assets/styles/variables.scss";

img.hero {
  border-radius: 20px;
  margin-bottom: 1em;
  cursor: pointer;
  width: 100%;
}

p {
  font-family: Poppins, sans-serif;
  padding-bottom: 5px;
  &.title {
    font-weight: bold;
    font-size: 1.6rem;
  }

  &.tagline {
    font-size: 1.2rem;
  }
}

.info-block {
  max-width: 90%;
}

.col {
  justify-content: space-between;
}

.icon {
  height: fit-content;
  max-width: calc(min(40px, 10%));
  align-self: flex-end;
}

.card-container-outline {
  border-color: $blue;
  position: relative;
  height: calc(100% - 2em);
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &:hover {
    background-color: $cream-hover;
    cursor: pointer;
  }
}

img.tag-highlight {
  position: absolute;
  top: 25px;
  left: 25px;
  width: 120px;
  max-width: 20%;
}

@keyframes wiggle {
  0% { transform: rotate(0deg); }
  25% { transform: rotate(10deg); }
  50% { transform: rotate(-10deg); }
  75% { transform: rotate(5deg); }
  100% { transform: rotate(0deg); }
}

/* The magic chain: Trigger the animation on the tag ONLY when the parent is ready */
.animate-now .tag-highlight {
  animation: wiggle 0.8s ease-in-out;
  transform-origin: center;
}


</style>